export const TEXTS = {
  GREETING_TEXT: 'Hey,',
  GREETING_GUEST_NAME: 'there!',
  ASK_TO_LOGIN: 'Login Now ',
  LOGGED_IN_MSG: 'Logged in via ',
  VERIFY_MOBILE_LABEL: 'Verify your mobile number',
  VERIFY_EMAIL_LABEL: 'Verify your email id',
};
